import Icon from '@src/basic-components/Icon/Icon';
import type { ElementType, FC, SelectHTMLAttributes } from 'react';
import { cn } from '../../utils/ui';

export interface SelectProps extends Omit<SelectHTMLAttributes<HTMLSelectElement>, 'className' | 'size'> {
    className?: string;
    hasError?: boolean;
    isDisabled?: boolean;
    iconClassName?: string;
    as?: ElementType;
}

const Select: FC<SelectProps> = props => {
    const { className, hasError = false, isDisabled = false, iconClassName, children, as = 'select', ...rest } = props;

    const Component = as;

    function getBaseStyle(): string {
        const baseClasses = 'cursor-pointer border text-xs rounded-lg min-h-7 px-2 pr-7 [field-sizing:content]';
        const appearanceClasses = '[appearance:none] [-webkit-appearance:none] [-moz-appearance:none]';

        if (hasError) return cn(baseClasses, appearanceClasses, 'border-red-500 text-red-500 dark:border-red-500 dark:text-red-500', className);

        return cn(baseClasses, appearanceClasses, 'border-gray-900 text-gray-900 dark:border-gray-50 dark:placeholder-gray-400 dark:text-white', className);
    }

    function getIconStyle(): string {
        const baseIconClasses = 'absolute text-base -translate-y-1/2 pointer-events-none right-2 top-1/2';

        if (hasError) return cn(baseIconClasses, 'text-red-500 dark:text-red-500');

        return cn(baseIconClasses, 'text-gray-900 dark:text-gray-50');
    }

    function renderIcon() {
        return <Icon className={cn(getIconStyle(), iconClassName)} name={'caretDown'} />;
    }

    return (
        <div className="relative inline-block">
            <Component className={getBaseStyle()} disabled={isDisabled} {...rest}>
                {children}
            </Component>
            {renderIcon()}
        </div>
    );
};

export default Select;
